// Marks, per browser session, that this user's own "Start Event" succeeded for the event.
//
// `POST /meeting/{id}/start` returning 200 does not mean `GET /event/{id}` already reports STARTED —
// the event's own status flip lags the meeting start, and the `eventStarted` WS frame is the signal
// that closes the gap. The join page force-refetches on mount, so an optimistic cache patch cannot
// cover that window; this marker can. sessionStorage (same rationale as greenRoomSession) survives a
// reload in the same tab but not a fresh tab or a bookmarked URL, so it is durable state rather than
// the ephemeral `location.state` the removed `withInnerRoute` gate relied on.
const storageKey = (eventId: number | string) => `natter-event-started-${eventId}`;

export const markEventStarted = (eventId: number | string): void => {
  sessionStorage.setItem(storageKey(eventId), '1');
};

export const hasJustStartedEvent = (eventId: number | string): boolean =>
  sessionStorage.getItem(storageKey(eventId)) === '1';

export const clearEventStarted = (eventId: number | string): void => {
  sessionStorage.removeItem(storageKey(eventId));
};
